import { accountRoles } from '../../common/enums';
import TopUpTool from './tools/TopUpTool';
import SmsLogTool from './tools/SmsLogTool';
import CreateAccountTool from './tools/CreateAccountTool';

// `roles` limits a tool to specific account roles; omit for creditors only.
// The SMS log is also for staff (admins verify what the sender produced).
const toolRegistry = [
  { id: 'create-account', label: 'Vytvoriť účet', description: 'Vytvoriť pripravený účet dlžníka alebo investora na testovanie', component: CreateAccountTool, roles: [accountRoles.ADMINISTRATOR] },
  { id: 'topup', label: 'Top up balance', description: 'Add test funds to your account', component: TopUpTool, roles: [accountRoles.CREDITOR] },
  { id: 'sms-log', label: 'Sent SMS log', description: 'List the most recent sent SMS messages', component: SmsLogTool, roles: [accountRoles.ADMINISTRATOR, accountRoles.OPERATOR, accountRoles.CALL_CENTRUM, accountRoles.CREDITOR] },
];

export default toolRegistry;



// WEBPACK FOOTER //
// ./src/features/test-tools/toolRegistry.js